/** @jsxImportSource @emotion/react */
import React, { useState } from 'react'
import { css } from '@emotion/react'
import { View } from '@components/atoms'
import { ProductListItem } from '@components/molecules'
import { ProductUpdateType, Product, ProductType } from '@schemas'
import { ProductDeleteConfirmationModal } from '@components/molecules'
import { ProductModificationModal } from '@components/molecules'
import { useAppDispatch } from '@redux/index'
import { productActions } from '@redux/store/index'

interface ProductListProps {
	products: ProductType[]
	selectedProductId: string
	onProductClick: (product: ProductType) => void
}

export const ProductList = ({
	products,
	onProductClick,
	selectedProductId,
}: ProductListProps) => {
	const dispatch = useAppDispatch()
	const [deleteModalOpen, setDeleteModalOpen] = useState(false)
	const [modifyModalOpen, setModifyModalOpen] = useState(false)
	const [selectedProduct, setSelectedProduct] = useState<ProductType>({
		...new Product(),
	})

	const handleDeleteClick = (product: ProductType) => {
		setSelectedProduct(product)
		setDeleteModalOpen(true)
	}

	const handleModifyClick = (product: ProductType) => {
		setSelectedProduct(product)
		setModifyModalOpen(true)
	}

	const handleDelete = () => {
		if (selectedProduct) {
			dispatch(productActions.DELETE_PRODUCT(selectedProduct.id))
			setDeleteModalOpen(false)
			setSelectedProduct(new Product())
		}
	}

	const handleModify = (updatedProduct: ProductUpdateType) => {
		dispatch(productActions.UPDATE_PRODUCT(updatedProduct))
		setModifyModalOpen(false)
		setSelectedProduct(new Product())
	}

	return (
		<View css={style}>
			<View className="productListView">
				{products?.map(product => {
					const isSelected = product.id === selectedProductId
					return (
						<ProductListItem
							key={product.id}
							{...product}
							isSelected={isSelected}
							onClick={() => onProductClick(product)}
							onDelete={() => handleDeleteClick(product)}
							onEdit={() => handleModifyClick(product)}
						/>
					)
				}) || <p>No products available.</p>}
			</View>

			<ProductDeleteConfirmationModal
				open={deleteModalOpen}
				onClose={() => setDeleteModalOpen(false)}
				onDelete={handleDelete}
				productName={selectedProduct ? selectedProduct.name : ''}
			/>
			<ProductModificationModal
				open={modifyModalOpen}
				onClose={() => setModifyModalOpen(false)}
				onSubmit={handleModify}
				initialValues={selectedProduct}
			/>
		</View>
	)
}

const style = css({
	overflow: 'auto',
	height: '100%',
	width: '100%',
	padding: '0.5rem 1rem',

	productListView: {},
})
